import { render } from "./StartPayment.vue?vue&type=template&id=20c2aa40&scoped=true"
import script from "./StartPayment.vue?vue&type=script&lang=js"
export * from "./StartPayment.vue?vue&type=script&lang=js"

import "./StartPayment.vue?vue&type=style&index=0&id=20c2aa40&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c2aa40"]])

export default __exports__